<div
  class="container"
  nz-flex
  [nzVertical]="false"
  nzJustify="space-between"
  nzAlign="center"
>
  <div
    nz-flex
    [nzVertical]="false"
    nzJustify="start"
    nzAlign="center"
    nzGap="0.5rem"
  >
    <img
      src="assets/images/longhealth-navbar-logo.png"
      alt=""
      class="logo-image"
    />
  </div>
  <div
    class="btn-container"
    nz-flex
    [nzVertical]="false"
    nzJustify="end"
    nzAlign="center"
    nzGap="1rem"
  >
    <div
      class="trust-badges"
      nz-flex
      [nzVertical]="false"
      nzAlign="center"
      nzGap="0.5rem"
    >
      <img src="assets/images/hipaa_b&w.png" alt="" class="hipaa-badge" />
      <img
        src="assets/images/hitrust-logo.png"
        alt="HITRUST Certified r2"
        class="hitrust-badge"
      />
    </div>
    <a
      class="footer-links"
      href="https://www.longhealth.io/terms-and-conditions"
      target="_blank"
      rel="noopener noreferrer"
      >Terms and Conditions</a
    >
    <a
      class="footer-links"
      href="https://www.longhealth.io/policies"
      target="_blank"
      rel="noopener noreferrer"
      >Privacy Policy</a
    >
  </div>
</div>
